export default "__VITE_ASSET__BvDGEx2N__"